export default __webpack_public_path__ + "static/media/Grocery_Logo.7bdd8129.png";